import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'identificationType'
})

export class IdentificationTypePipe implements PipeTransform {
    transform(identificationTypes: any, countryCode: string, countries: any): any {
        if (countryCode && countries && countries.length > 0) {
            const selectedCountry = countries.find(country => country.isocodeThree.toLowerCase() === countryCode.toLowerCase());
            if (selectedCountry && identificationTypes && identificationTypes.length) {
                return identificationTypes.filter(x => x.countryID == selectedCountry.countryId);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/pipes/identification-type.pipe.ts